import { getLocalStorage, setLocalStorage } from './localStorage'
// straight from the module, not the barrel: helpers/constants/index re-exports
// list.js, which imports apiServices and pulls this back into a cycle
import { LOCAL_STORAGE } from '../constants/localStorage'

const generateUuid = () => {
	if (window.crypto && window.crypto.randomUUID) {
		return window.crypto.randomUUID()
	}
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0
		const v = c === 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
}

// Identifies the browser, not the user, so one agent logging in from two
// machines is two rows in tbl_devices. Kept in its own localStorage key because
// logout clears USER_AUTH and the same browser must keep its row on next login.
// The `WEB-` prefix must stay: the API sweeps idle sessions with
// `device_id LIKE 'WEB-%'`, the only indexed way to scope that query.
export const getDeviceId = () => {
	const saved = getLocalStorage(LOCAL_STORAGE.DEVICE_ID)
	if (saved) return saved
	const deviceId = `WEB-${generateUuid()}`
	setLocalStorage(LOCAL_STORAGE.DEVICE_ID, deviceId)
	return deviceId
}
